import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';

import AampeTooltip from '../shared/AampeTooltip/AampeTooltip';

interface WhatsNewButtonProps {
    version: string;
    hasUnseen: boolean;
    collapsed: boolean;
    onClick: () => void;
}

const WhatsNewButton: React.FC<WhatsNewButtonProps> = ({
    version,
    hasUnseen,
    collapsed,
    onClick,
}) => {
    const label = `What's new, version ${version}${
        hasUnseen ? ', new updates' : ''
    }`;
    if (collapsed) {
        return (
            <AampeTooltip title={`What's new (v${version})`} placement="right">
                <IconButton type="button" onClick={onClick} aria-label={label}>
                    <ICONS.sparkle width={16} height={16} />
                    {hasUnseen && <OverlayDot data-testid="whats-new-dot" />}
                </IconButton>
            </AampeTooltip>
        );
    }

    return (
        <button type="button" onClick={onClick} aria-label={label}>
            <ICONS.sparkle width={16} height={16} />
            What's new
            <Version>v{version}</Version>
            {hasUnseen && <UnseenDot data-testid="whats-new-dot" />}
        </button>
    );
};

const IconButton = styled.button({
    position: 'relative',
});

const Version = styled.span({
    color: aampeTheme.colors.solidWG01,
    fontSize: aampeTheme.size.font.textExtraSmall,
});

const UnseenDot = styled.span({
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: aampeTheme.colors.blue700,
    flexShrink: 0,
});

const OverlayDot = styled(UnseenDot)({
    position: 'absolute',
    top: 0,
    right: '-2px',
});

export default WhatsNewButton;
